<template>
	<div class="personal-wrapper">
		<div class="weui-cell weui-cell-top weui-cell_active">
			<div class="weui-cell__hd" style="position: relative; margin-right: 10px; margin-left: 30px">
				<img src="../../../common/img/person.png" style="width: 60px; display: block;"/>
			</div>
			<div class="weui-cell__bd">
				<p>贵宾用户</p>
				<p style="font-size: 15px; padding: 2px 6px; letter-spacing: 2px;font-weight: 500">{{userInfo.phonenumber}}</p>
			</div>
		</div>
		<div class="weui-cells">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">您当前账号余额</div>
				<div class="weui-cell__ft weui-cell__cash" style="font-size: 0;">
					<span style="vertical-align: middle; font-size: 17px;">{{userInfo.balance}}元</span>
				</div>
			</div>
		</div>

		<div class="weui-cells" @click="toBindPlate">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">绑定车牌</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>

		<div class="weui-cells" @click="toWriteReceipt">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">开具发票</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>
		<div class="weui-cells" @click="clearLocalData">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<!-- <span style="vertical-align: middle;">清除本地缓存</span> -->
					<span style="vertical-align: middle;">退出登录</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>
	</div>
</template>

<script>
    import { getWxUserInfo } from "../../../api/coupon/personalCenter";
    import { plateList } from "../../../api/coupon/bindPlate";
    import { mapGetters } from 'vuex'
    export default {
        name: "index",
        data () {
            return {
                userInfo: {},
                plateList: []
            }
        },
        computed: {
            ...mapGetters(['userOpenid'])
        },
        mounted () {
            if (localStorage.getItem('userOpenId')||this.userOpenid  ) this.getUserInfo();
            if ( localStorage.getItem('userOpenId')||this.userOpenid ) this.getPlateList();
        },
        methods: {
            /*获取绑定车牌列表**/
            getPlateList () {
                plateList({openid: localStorage.getItem('userOpenId')||this.userOpenid }).then(res =>{
                    this.plateList = res.data;
                })
            },
            toBindPlate () {
                if (this.plateList && this.plateList.length > 0){
                    this.$router.push({name:'plateInfo'})
                } else {
					localStorage.removeItem("userOpenId")
                    this.$router.push({path:'bindPlate',query:{comeFrom:'plateInfo'}})
                }
            },
            toWriteReceipt () {
                this.$router.push('receiptOptions')
			},
            clearLocalData () {
                // this.$weui.confirm('确认清除本地缓存？',{
                //     buttons: [{
                //         label: '取消',
                //         type: 'default',
                //     }, {
                //         label: '确认',
                //         type: 'primary',
                //         onClick: () => {
                //             localStorage.clear()
                //         }
                //     }]
                // })
				this.$weui.confirm('确认退出登录？',{
                    buttons: [{
                        label: '取消',
                        type: 'default',
                    }, {
                        label: '确认',
                        type: 'primary',
                        onClick: () => {
							localStorage.clear()
                            this.$router.replace({ name: 'register' });
                        }
                    }]
				})
			},
            /*获取用户信息**/
            getUserInfo () {
                getWxUserInfo(localStorage.getItem('userOpenId')||this.userOpenid  ).then(res =>{
                    if (res.code == 200 && res.hasOwnProperty('data')){
                        this.userInfo = res.data;
                        this.userInfo.balance = parseFloat(res.data.balance).toFixed(2)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="stylus">
	.weui-cell-top{
		width 100%
		height 100px
		background-image url("../../../common/img/background.jpeg")
		background-position center
		.weui-cell__hd {
			border-radius 30px
			img{
				width 100%
				height 100%
				position center
			}
		}
		.weui-cell__bd{
			width 60%
			color #fff
			p{
				width 100%
				padding 5px
			}
		}
	}
	.weui-cells{
		margin-top 0
		.weui-cell_access{
			display flex
			justify-content space-between
		}
	}
	.weui-cell_access .weui-cell__cash{
		padding-right 0
	}
	.weui-cell_access .weui-cell__cash:after{
		width 0
		height 0
		border-width 0
	}
	.weui-cell__ft::after{
		content:" ";
		display:inline-block;
		height:8px;
		width:8px;
		border-width:2px 2px 0 0;
		border-color:#B2B2B2;
		border-style:solid;
		-webkit-transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position:absolute;
		top:50%;
		margin-top:-5px;
		right:0;
	}
</style>
